import { Menu } from 'lucide-react';
import { useMobileNavStore } from '@/stores/mobileNavStore';

/** Opens the app menu from the full-screen phone entry screens, which cover the app header. */
export function PhoneMenuButton({ confirmLeave = false }: { confirmLeave?: boolean }) {
  const setOpen = useMobileNavStore((s) => s.setOpen);
  return (
    <button
      type="button"
      aria-label="Menu"
      onClick={() => {
        // Picking a destination from the menu leaves the screen, same as the back arrow.
        if (confirmLeave && !window.confirm('Some values are not saved. Leave anyway?')) return;
        setOpen(true);
      }}
      className="-mr-2 flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-lg text-gray-900 active:bg-gray-100"
    >
      <Menu className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
